{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2022                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit dateutils.helper;

{$Mode Delphi}

interface

uses
  Generics.Defaults, Generics.Collections;

type
  TDSTPoints = TPair<TDateTime, TDateTime>;

  TDateUtilsHelper = class(TObject)
  strict private
    FCache: TDictionary<Integer, TDSTPoints>;
    function CalcPoints(const AYear: Integer; out AValue: TDSTPoints): Boolean;
    function Find(const AYear: Integer; out AResult: TDSTPoints): Boolean;
  public
    constructor Create;
    destructor Destroy; override;
    function Force(const AYear: Integer; out AValue: TDSTPoints): Boolean;
  end;

implementation

uses
  SysUtils, JS;

{ TDateUtilsHelper }

constructor TDateUtilsHelper.Create;
begin
  inherited Create;
  FCache := TDictionary<Integer, TDSTPoints>.Create;
end;

destructor TDateUtilsHelper.Destroy;
begin
  FCache.Free;
  inherited Destroy;
end;

function TDateUtilsHelper.CalcPoints(const AYear: Integer; out AValue: TDSTPoints): Boolean;
const
  cJanuary = 0;
  cDecember = 11;
var
  lMonth: Integer;
  lDay: Integer;
  lHour: Integer;
  lDate: TJSDate;
  lOffset: NativeInt;
  lOffsetNext: NativeInt;
  lFirst: Boolean;
  lDateTime: TDateTime;
begin
  lFirst := True;
  for lMonth := cJanuary to cDecember do
  begin
    for lDay := 1 to MonthDays[IsLeapYear(AYear)][lMonth + 1] do
    begin
      for lHour := 0 to HoursPerDay - 1 do
      begin
        lDate := TJSDate.New(AYear, lMonth, lDay, lHour);
        lOffset := lDate.getTimezoneOffset;

        lDate.Hours := lDate.Hours + 1;
        lOffsetNext := lDate.getTimezoneOffset;

        if lOffset <> lOffsetNext then
        begin
          lDateTime := EncodeDate(AYear, lMonth + 1, lDay);
          if lFirst then
            AValue.Key := lDateTime + EncodeTime(lHour + 1, 0, 0, 0)
          else
            AValue.Value := lDateTime + EncodeTime(lHour, 0, 0, 0);
          lFirst := False;
        end;
      end;
    end;
  end;
  Result := not lFirst;
  if Result then
    FCache.Add(AYear, AValue);
end;

function TDateUtilsHelper.Find(const AYear: Integer; out AResult: TDSTPoints): Boolean;
begin
  Result := FCache.TryGetValue(AYear, AResult);
end;

function TDateUtilsHelper.Force(const AYear: Integer; out AValue: TDSTPoints): Boolean;
begin
  Result := Find(AYear, AValue);
  if not Result then
    Result := CalcPoints(AYear, AValue);
end;

end.

